import React, {FunctionComponent} from 'react';
import StyleInjector from '../../helper/StyleInjector';

export type  BreadcrumbItemProps = {
    dataItem: number,
    active?: boolean
}

const BreadcrumbItem: FunctionComponent<BreadcrumbItemProps> = (props) => {

    return (
        <li className={`dfb-Breadcrumb-item${props.active ? ' is-active' : ''}`} data-item={props.dataItem}>
            <StyleInjector className="dfb-Breadcrumb-link">{props.children}</StyleInjector>
        </li>
    );
};

BreadcrumbItem.defaultProps = {
    active: false
};

export default BreadcrumbItem;
